import { Subscription } from 'rxjs';

export class SubscriptionManager {
  private subscriptions: Subscription[] = [];

  set manage(value: Subscription) {
    if (!value || this.subscriptions.includes(value)) {
      return;
    }

    this.subscriptions.push(value);
  }

  unsubscribe() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
